export const lenisRef = { current: null };

export const scrollTo = (target) => {
  if (lenisRef.current) {
    lenisRef.current.scrollTo(target, { offset: -72, duration: 1.3 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
